/*
 * Yafeapedia
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.57
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The CategoryDTO model module.
 * @module model/CategoryDTO
 * @version 1.0.1
 */
export default class CategoryDTO {
  /**
   * Constructs a new <code>CategoryDTO</code>.
   * @alias module:model/CategoryDTO
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>CategoryDTO</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CategoryDTO} obj Optional instance to populate.
   * @return {module:model/CategoryDTO} The populated <code>CategoryDTO</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new CategoryDTO();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('nameAr'))
        obj.nameAr = ApiClient.convertToType(data['nameAr'], 'String');
      if (data.hasOwnProperty('nameEn'))
        obj.nameEn = ApiClient.convertToType(data['nameEn'], 'String');
      if (data.hasOwnProperty('parent'))
        obj.parent = CategoryDTO.constructFromObject(data['parent']);
      if (data.hasOwnProperty('isMediaCategory'))
        obj.isMediaCategory = ApiClient.convertToType(data['isMediaCategory'], 'Boolean');
      if (data.hasOwnProperty('imgCover'))
        obj.imgCover = ApiClient.convertToType(data['imgCover'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} id
 */
CategoryDTO.prototype.id = undefined;

/**
 * @member {String} nameAr
 */
CategoryDTO.prototype.nameAr = undefined;

/**
 * @member {String} nameEn
 */
CategoryDTO.prototype.nameEn = undefined;

/**
 * @member {module:model/CategoryDTO} parent
 */
CategoryDTO.prototype.parent = undefined;

/**
 * @member {Boolean} isMediaCategory
 */
CategoryDTO.prototype.isMediaCategory = undefined;

/**
 * @member {String} imgCover
 */
CategoryDTO.prototype.imgCover = undefined;

